<template>
  <div class="d-flex align-center">
    <!--    <v-btn class="ma-2 rounded-lg" color="blue lighten-2" dark depressed large @click="goto('phonebook/new')">-->
    <!--      <v-icon left>mdi-plus</v-icon>-->
    <!--      ایجاد مخاطب-->
    <!--    </v-btn>-->

    <slot name="toggle"/>

    <v-menu v-model="menu" :close-on-content-click="false" content-class="rounded-lg" min-width="200" offset-y right>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="mx-2" icon v-bind="attrs" v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-card class="rounded-lg" flat>
        <v-list class="transparent" dense>
          <v-list-item disabled @click="openPrint">
            <v-list-item-icon>
              <v-icon>mdi-printer-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>چاپ</v-list-item-title>
          </v-list-item>

          <v-list-item :disabled="downLoading" @click="downloadExcel">
            <v-list-item-icon>
              <v-icon>mdi-file-excel-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>خروجی اکسل</v-list-item-title>
          </v-list-item>

          <v-list-item v-if="hasPhonebookPermission('delete')" :disabled="!selectedIds.length || loading"
                       @click="deleteSelected">
            <v-list-item-icon>
              <v-icon v-if="!loading" :color="!selectedIds.length ? '' : 'red'">mdi-trash-can-outline</v-icon>
              <v-progress-circular v-else color="blue" indeterminate size="24" width="4"/>
            </v-list-item-icon>
            <v-list-item-title>حذف</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "contactsMenu",

  props: {
    phoneTag: Object,
    selectedIds: Array
  },

  data: () => ({
    menu: false,
    downLoading: false,
    loading: false,
  }),

  methods: {
    openPrint() {
      window.open()
    },
    downloadExcel() {
      this.downLoading = true

      let url = `contact${this.$route.name === 'admin.contact.monitoring' ? '/admin' : ''}/excel`

      this.requestApiGetPayamak(url, {
        phone_tag: this.phoneTag.id
      })
        .then(({data}) => {
          if (data.download_url) {
            const a = document.createElement('a');
            let moment = require('moment-jalaali')
            a.setAttribute('download', 'contact-excel_' + moment().format('jYYYY-jMM-jDD HH:mm:ss'))
            a.setAttribute('href', data.download_url)

            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }
        })
        .catch(({response}) => console.log('failed to download contact excel: ', response))
        .finally(() => this.downLoading = false)
    },
    deleteSelected() {
      this.loading = true

      this.requestApiDeletePayamak('contact/phoneTag/group', {
        phoneTag: this.phoneTag.id,
        ids: this.selectedIds.map(item => item.id)
      })
        .then(({data}) => {
          this.menu = false
          this.$emit('reload')
          this.$toast.success('با موفقیت حذف شد.')
        })
        .catch(({response}) => {
          this.$toast.error('خطا در حذف مخاطبین!')
          console.log('failed to group deleting ids: ', response)
        })
        .finally(() => this.loading = false)
    }
  }
}
</script>

<style scoped>

</style>